(function () {
    'use strict';

    angular
        .module('app.audit')
        .controller('AuditLoggingController', AuditLoggingController);
    /*jshint -W071, -W072 */
    /* @ngInject */
    function AuditLoggingController(
        $q,
        auditService,
        $uibModal,
        $state,
        logger,
        moment) {

        //Private Variables
        var vm = this;

        //Public Variables
        vm.applications = [];
        vm.eventTypes = [];

        // Inititalization
        vm.title = 'Audit Logging Management';
        vm.loadingMessage = 'Loading ... ';
        var auditModalOptions = auditService.getModalOptions();

        vm.auditlogs = [];

        //Public Methods
        //vm.getAuditLogs = auditService.getAuditLogs;
        vm.getAuditLogs = auditService.getAuditLogsBySettings;
        vm.eventTypes = [];
        vm.viewDetails = viewDetails;

        // Smart Table
        vm.tableConfig = undefined;
        vm.datePickerOptions = {
            singleDatePicker: false,
            showDropdowns: false,
            opens: 'right',
            drops: 'down',
            alwaysShowCalendars: true,
            showCustomRangeLabel: false,
            timePicker: true,
            timePickerIncrement: 30,
            ranges: {
                'Last 7 Days': [
                    moment().subtract(1, 'weeks'),
                    moment()
                ],
                'Last 30 Days': [
                    moment().subtract(1, 'months'),
                    moment()
                ]
            },
            locale: {
                format: 'MM/DD/YYYY h:mm A'
            }
        };

        // DI / IOC / unit testing / mocking
        vm.auditService = auditService;

        //Activate Controller
        activate();

        function activate() {
            var auditLogsPromise = auditService.getSchemaTypes().then(function (schemas) {                
                vm.applications = schemas.data;
            });
            var eventTypesPromise = auditService.getEventTypes().then(function (events) {
                vm.eventTypes = events;
            });

            var promises = [auditLogsPromise, eventTypesPromise];
            return $q.all(promises)
                .then(function () {
                    configureTableActions();
                    logger.info('Activated audit logging dashboard View');
                });
        }

        function configureTableActions() {
            var tableConfig = auditService.getTableConfig();
            tableConfig.columns[0].options = vm.eventTypes.map(function(eventType) {
                return {
                    value: eventType.AuditEventTypeId,
                    name: eventType.EventName
                };
            });
            var schemaTypes = [];
            angular.forEach(vm.applications, function(log) {
                var hasSchema = schemaTypes.indexOf(log.SchemaName);
                if (hasSchema === -1) {
                    schemaTypes.push(log.SchemaName);
                }
            });
            tableConfig.columns[2].options = schemaTypes.map(function (schemas) {
                return {
                    value: schemas,
                    name: schemas
                };
            });
            tableConfig.actions = [
                {
                    name: '"View Details"',
                    action: viewDetails,
                    icon: '"fa-eye"',
                    permission: ['SSO:SysAdmin', 'SSO:AppAdmin']
                }];
            vm.tableConfig = tableConfig;
        }

        function viewDetails(auditLog) {
            auditModalOptions.controller = 'AuditDetailsController';
            var modalInstance = $uibModal.open(angular.extend({
                resolve: {
                    auditLog: function () {
                        return angular.copy(auditLog);
                    }
                }
            }, auditModalOptions));

            modalInstance.result.then(function (updatedAuditLog) {
                //angular.extend(auditLog, updatedAuditLog);
                logger.info('Audit Log Detail Modal dismissed at: ' + moment().format());
            }, function () {
                logger.info('Audit Log Detail Modal dismissed at: ' + moment().format());
            });
        }
    }

})();
